import { Redirect } from 'react-router-dom';

export default function NotFoundRedirect() {
  return <Redirect to="/404" />;
}
